// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {

	LOGOUT_USER,
	BOOKING_LOAD_BOOKING_LIST,
	BOOKING_LOAD_BOOKING_LIST_SUCCESS,
	BOOKING_LOAD_ALL_PAYMENT_BOOKING_LIST_SUCCESS,
	BOOKING_LOAD_BOOKING_TOPBAR,
	BOOKING_LOAD_BOOKING_TOPBAR_SUCCESS,

} from '../actions';

const INIT_STATE = {

	bookingLoading: false,
	bookinglist: [],
	allPaymentBookinglist: [],
	bookingTopbarData: {},
	// dataCompanyInformation: null,

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case BOOKING_LOAD_BOOKING_LIST:
			return { ...state, bookingLoading: true, }
		case BOOKING_LOAD_BOOKING_LIST_SUCCESS:
			return { ...state, bookingLoading: false, bookinglist: action.payload }
		case BOOKING_LOAD_ALL_PAYMENT_BOOKING_LIST_SUCCESS:
			return { ...state, bookingLoading: false, allPaymentBookinglist: action.payload }
		case BOOKING_LOAD_BOOKING_TOPBAR:
			return { ...state, bookingLoading: true, }
		case BOOKING_LOAD_BOOKING_TOPBAR_SUCCESS:
			return { ...state, bookingLoading: false, bookingTopbarData: action.payload }
		case LOGOUT_USER:
			return {
				...state,
				bookingLoading: false,
				bookinglist: [],
				allPaymentBookinglist: [],
				bookingTopbarData: {},
			};

		default: return { ...state };
	}
}